const hosts = {
  SERVER: process.env.REACT_APP_SERVER_URL,
};

export default hosts;
